import * as React from 'react';
import { ReactModalAdaptor } from '../../helpers';
import { CloseModalButton, CloseIcon, CloseIconWrap, ContentCenter } from './styles';

// eslint-disable-next-line @typescript-eslint/ban-types
export const Modal = ({
  modalIsOpen,
  toggleModal,
  children,
}: // eslint-disable-next-line @typescript-eslint/no-explicit-any
React.ComponentProps<any>): JSX.Element => {
  return (
    <ReactModalAdaptor
      closeTimeoutMS={200}
      isOpen={modalIsOpen}
      onRequestClose={toggleModal}
      shouldCloseOnOverlayClick={true}
    >
      <CloseIconWrap>
        <CloseModalButton onClick={toggleModal}>
          <CloseIcon className="far fa-times-circle" />
        </CloseModalButton>
      </CloseIconWrap>
      <ContentCenter>{children}</ContentCenter>
    </ReactModalAdaptor>
  );
};
